import { useNavigate } from "react-router-dom";
import { paths } from "../routes/paths";
import styles from "../styles/_layouts/header.module.scss";

const Header = () => {
  const navigate = useNavigate();
  return (
    <header className={styles.header}>
      <div className={styles.wrapper}>
        <img
          src="/assets/logo.png"
          alt="logo"
          className={styles.logo}
          onClick={() => navigate(paths.home)}
        />
      </div>
    </header>
  );
};

export default Header;
